import { MapTo } from '@adobe/aem-react-editable-components';
import Level3Questions, { Level3QuestionsEditConfig } from './Level3Questions';

export default MapTo(
    'cob-corp-acquisition/components/creditonebank/level-3-questions',
)(Level3Questions, Level3QuestionsEditConfig);